<template>
  <div v-if="data" class="d-fast-payment-system">
    <h3 class="d-fast-payment-system__title">
      <span>Оплата заказа № {{ data.orderNumber }} <span class="nowrap">по QR-коду</span></span>

      <f-sprite-icon
        :icon-link="$options.icons.IconSpb.id"
        class="d-fast-payment-system__spb-icon"
      />
    </h3>

    <div class="d-fast-payment-system__price">
      Сумма заказа:<span>{{ data.totalPrice | price }} ₽</span>
    </div>

    <div class="d-fast-payment-system__content">
      <div class="d-fast-payment-system__qr">
        <ui-loader
          v-if="loading"
          size="64"
          class="d-fast-payment-system__loader"
        />

        <canvas ref="qr" />
      </div>

      <ol class="d-fast-payment-system__list">
        <li>
          Наведите камеру смартфона на QR-код
        </li>
        <li>
          На экране появится выбор приложения банка. Следуйте дальнейшим инструкциям в&nbsp;телефоне.
          Если не сработало, переходите к&nbsp;шагу&nbsp;3
        </li>
        <li>
          Откройте приложение банка в телефоне, перейдите в&nbsp;раздел «Платежи»
        </li>
        <li>
          Выберите пункт «Оплата по QR-коду»
          и&nbsp;отсканируйте QR-код
        </li>
        <li>
          Заказ сформируется в течение минуты после оплаты
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode';

import IconSpb from '@icons/spb.multi.svg';

export default {
  name: 'd-fast-payment-system',

  icons: {
    IconSpb,
  },

  props: {
    data: {
      type: Object,
      default: null,
    },
  },

  data: () => ({
    loading: true,
  }),

  mounted() {
    if (!this.$refs.qr || !this.data?.qrUrl) return;
    QRCode.toCanvas(this.$refs.qr, this.data.qrUrl, { width: 205, margin: 2 }, (error) => {
      if (error) console.error(error);
      this.loading = false;
    });
  },
};
</script>

<style lang="scss">
.d-fast-payment-system {
  color: $black;

  &__title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0;
    font-family: Gilroy, sans-serif;
    font-weight: 600;
    font-size: 20px;
    line-height: 28px;
  }

  &__spb-icon.sprite-icon {
    width: 116px;
    height: 58px;
    margin: 0 13px 0 16px;
  }

  &__price {
    font-weight: 400;
    font-size: 14px;
    line-height: 32px;
    margin: 16px 0 52px;

    span {
      font-weight: 600;
      font-size: 24px;
      line-height: 32px;
      margin-left: 8px;
    }
  }

  &__content {
    display: flex;
  }

  &__qr {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 205px;
    height: 205px;
    margin-right: 55px;
  }

  &__loader {
    position: absolute;
    color: $blue;
  }

  &__list {
    margin: 0;
    padding: 0;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    counter-reset: liCounter;

    li {
      position: relative;
      display: flex;
      align-items: center;
      padding-left: 36px;
      min-height: 24px;

      &:not(:last-child) {
        margin-bottom: 16px;
      }
    }

    li::before {
      position: absolute;
      top: 0;
      left: 0;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: 24px;
      height: 24px;
      counter-increment: liCounter;
      content: counter(liCounter);
      border-radius: 12px;
      color: $white;
      background: $blue;
      font-weight: 600;
      font-size: 14px;
      line-height: 1;
    }
  }

  .nowrap {
    white-space: nowrap;
  }
}
</style>
